export default {
  HighestValue: 'highestValue',
  HighestOrder: 'highestOrder',
}
